import useMutationCall from "../../../hooks/useMutationCall";
import { useCreateActivityMutation } from "../timelogsSlice";

const useCreateActivity = () => {
  return useMutationCall(useCreateActivityMutation);
};

export default useCreateActivity;
